import platform from 'platform'

import http  from './http.js'

let instance = null;

class Authentification{
    constructor( baseURL = null, loginPath='/login', registerPath = '/register', logoutPath = '/logout' , authPath = '/me'){
        this._suscribers = {
            change: [],
            ready: []
        }
        this.baseURL = baseURL === null  ? `${window.location.protocol}//${window.location.host}` : baseURL
        this.loginPath = loginPath
        this.registerPath = registerPath
        this.logoutPath = logoutPath
        this.authPath = authPath
        
        http( this._axiosOptions() )
        this.http = http();
        this.init()
    }

    init(){
        this.check()
            .then( ()=>this._authReady() )
            .catch( ()=>this._authReady() )     
    }

    _axiosOptions(){
        return this.token() === null ? {
            withCredentials: true,
            baseURL : this.baseURL,
            headers: { 'Accept': 'application/json' },
        } : {
            withCredentials: true,
            baseURL : this.baseURL,
            headers: {'Authorization': `Bearer ${this.token()}`, 'Accept': 'application/json' },
        }
    }

    _authChange(){
        this._suscribers.change.forEach( async ( callback )=>{
            callback( {
                'user': await this.user(),
                'token' : this.token(),
                'axios' : this.http 
            } )
        } )
    }

    _authReady(){
        this._suscribers.ready.forEach( async ( callback )=>{
            callback( {
                'user': await this.user(),
                'token' : this.token(),
                'axios' : this.http 
            } )
        } )
    }

    on( event,  callback ){
        this._suscribers[event].push( callback )
    }

    token( newToken = null ){
        if( newToken !== null ){
            window.localStorage.setItem('token', newToken)
        }
        return window.localStorage.getItem('token')
    }

    check(){
        return new Promise( async (resolve, reject)=>{ // eslint-disable-line no-async-promise-executor
            const token = this.token()
            if( token !== null ){
                const user = await this.user()
                if(!user){
                    reject({'user':null, 'token':null })
                }
                http( this._axiosOptions() )
                resolve({'user':user, 'token':token })
            }
            reject({'user':null, 'token':null })
        } )
    }

    async user(){
        let user = null
        try {
            user = ( await this.http.get( this.authPath ) ).data
            if( typeof user === 'string'){
                user = null
            }
        } catch (error) {
            return null
        }
        return user
    }

    deviceInfo(){
        return `${platform.name} ${platform.version} ${platform.os}`
    }

    login( email, password ){
        return new Promise((resolve, reject)=>{
            this.http.post( this.loginPath, {
                'email':email ,
                'password':password,
                'device_name' : this.deviceInfo()
            } )
            .then(()=>{
                console.log(email)
                resolve( email )
            })
            .catch((err)=>reject(err))
        })
    }

    checkAuthToken(email, token){
        return new Promise( (resolve, reject)=>{
            this.http.post(`${this.loginPath}/token`, {
                'email': email,
                'token': token,
                'device_name' : this.deviceInfo()
            })
            .then( async (response)=>{
                this.token(response.data)
                this.http = http( this._axiosOptions() )
                const user = await this.user()
                resolve({'user':user, 'token':response.data })
            } )
            .catch((err)=>reject(err))
        })
    }

    logout(){
        return new Promise( (resolve, reject)=>{
            this.http.delete( this.logoutPath ).then((r)=>resolve(r)).catch((err)=>{reject(err)})
        } )
    }

}


const createAuth = ( baseURL, loginPath, registerPath, logoutPath ,authPath ) => {
    instance = new Authentification( baseURL, loginPath, registerPath, logoutPath ,authPath )
    return instance
}

const auth = ()=>{
    if(instance === null){
        throw new Error("Authentification not initialized")
    }
    return instance
}

export { createAuth , auth }